import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import Swal from 'sweetalert2';
import { ExcelService } from 'src/app/services/excel.service';
import { InventarioService } from 'src/app/services/inventario.service';

@Component({
  selector: 'app-listadodereportes',
  templateUrl: './listadodereportes.component.html',
  styleUrls: ['./listadodereportes.component.css']
})
export class ListadodereportesComponent implements OnInit {

  ortopedicos: any = [];
  ortopedicospagado: any = [];

  resultados: any = [];

  // FILTROS — NUEVO
  tipoReporte: string = 'nopagado';
  fechaInicio: any = '';
  fechaFin: any = '';

  cargo: string;
  plantel: string;
  Nombre: string;

  datos = JSON.parse(localStorage.getItem('datos')!);
  mailusu = this.datos.correop;
  idplantel = this.datos.idplantel;

  planteles: any = [];

  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private excelService: ExcelService
  ) {
    this.datos = JSON.parse(localStorage.getItem('datos')!);
    this.cargo = this.datos.cargodb;
    this.idplantel = this.datos.idplantel;
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
  }

  ngOnInit(): void {
    this.getOrtopedicosCompuExcel();
    this.getOrtopedicospagadoCompuExcel();
  }

  getOrtopedicosCompuExcel() {
    this.inventarioService.getListaOrtopedicosExcel(this.idplantel).subscribe(
      res => {
        this.ortopedicos = res;
      },
      err => console.error(err)
    );
  }

  getOrtopedicospagadoCompuExcel() {
    this.inventarioService.getListaOrtopedicospagadoExcel(this.idplantel).subscribe(
      res => {
        this.ortopedicospagado = res;
      },
      err => console.error(err)
    );
  }

  // ╔═══════════════════════════════╗
  // ║      FILTRAR COMO BECAS      ║
  // ╚═══════════════════════════════╝
  buscarReportes() {

    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
        icon: 'warning',
        title: 'Faltan fechas',
        text: 'Debes seleccionar fecha de inicio y fecha de fin.',
        timer: 1800,
        showConfirmButton: false
      });
      return;
    }

    let origen = [];

    if (this.tipoReporte === 'nopagado') {
      origen = this.ortopedicos;
    } else if (this.tipoReporte === 'pagado') {
      origen = this.ortopedicospagado;
    } else if (this.tipoReporte === 'todos') {
      origen = [...this.ortopedicos, ...this.ortopedicospagado];
    }

    const inicio = new Date(this.fechaInicio);
    const fin = new Date(this.fechaFin);

    this.resultados = origen.filter((item: any) => {
      const fecha = new Date(item.fecha_factura || item.fecha_pagonomina);
      return fecha >= inicio && fecha <= fin;
    });
  }

  // ╔═══════════════════════════════╗
  // ║      EXPORTA COMO BECAS      ║
  // ╚═══════════════════════════════╝
  exportarExcel() {
    this.excelService.exportAsExcelFile(this.resultados, 'Reporte Ortopedicos Filtrado');
  }

}
